import { useEffect } from "react";

const META_PIXEL_ID = "2273947916427439";

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}

const loadPixel = () => {
  try {
    if (document.getElementById("fb-pixel-script")) return;

    const f = window;
    const b = document;
    if (f.fbq) return;
    const n: any = (f.fbq = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    });
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];

    const s = b.createElement("script");
    s.id = "fb-pixel-script";
    s.async = true;
    s.src = "https://connect.facebook.net/en_US/fbevents.js";
    s.onerror = () => {
      // Script blocked by ad-blocker — fail silently
    };
    b.head.appendChild(s);

    window.fbq("init", META_PIXEL_ID);
    window.fbq("track", "PageView");
  } catch {
    // Marketing tracking should never crash the app
  }
};

const MetaPixel = () => {
  useEffect(() => {
    loadPixel();
  }, []);

  return null;
};

export default MetaPixel;
